import React from 'react'
import "./contentarea.css"
import { useState } from 'react';
import {BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import Home from './Home';
import About from './About';
import Search from './Search';
import Books from './Books';
import bookdata from './bookdata';
import Contact from './Contact';
import { MdLibraryBooks } from "react-icons/md";




export const Contentarea = (props) => {
  const [isNavExpand, setIsNavExpand] = useState(false)

  const[bk,setBk]=useState([]);
  const [subject,changeSubject]=useState('');
  //           const handleSubject=()=>{
  //               return(
  //                   changeSubject('artificial intelligence'),setBk('bookdata.ai')
  //               )
  //           }
            // const handleBk=()=>{
            //   return(
            //     setBk(bookdata.ai)
            //   )
            // }

  
    
  return (
    <>
  <div className="wii" onClick={() => {setIsNavExpand(!isNavExpand);}}>
  <MdLibraryBooks color='green' size={40} />
  </div>
  <div className="container">
    <div className={isNavExpand ? "side expand" : "side"}>
    <ul>
        <li onClick={() => {setIsNavExpand(!isNavExpand);}}>
          <Link to="/books" onClick={()=>{setBk(bookdata.ai);changeSubject('Artificial Intelligence')}}>Artificial Intelligence</Link>
        </li>
        <li onClick={() => {setIsNavExpand(!isNavExpand);}}>
          <Link to="/books" onClick={()=>{setBk(bookdata.clanguage);changeSubject('C Language')}}>C Language</Link>
        </li>
        <li onClick={() => {setIsNavExpand(!isNavExpand);}}>
          <Link to="Computer Ahitecture.html"><del>Computer Architecture</del></Link>
        </li>
        <li>
          <Link to="Computer Graphics.html"><del>Computer Graphics</del></Link>
        </li>
        <li onClick={() => {setIsNavExpand(!isNavExpand);}}>
          <Link to="/books" onClick={()=>{setBk(bookdata.cpp);changeSubject('C Plus Plus(c++)')}}>C++</Link>
        </li>
        <li onClick={() => {setIsNavExpand(!isNavExpand);}}>
          <Link to="/books" onClick={()=>{setBk(bookdata.csharp);changeSubject('C Sharp(C#)')}}>C#</Link>
        </li>
        <li>
          <Link to="CyberSecurity.html"><del>Cyber Security</del></Link>
        </li>
        <li>
          <Link to="DLinktLinkStructure.html"><del>Data Structure</del></Link>
        </li>
        <li>
          <Link to="DBMS.html"><del>DBMS</del></Link>
        </li>
        <li>
          <Link to="JLinkvLink.html"><del>Java</del></Link>
        </li>
        <li>
          <Link to="MobileComputing.html"><del>Mobile Computing</del></Link>
        </li>
        <li>
          <Link to="Networking.html"><del>Networking</del></Link>
        </li>
        <li>
          <Link to="Networking.html"><del>OperLinkting System</del></Link>
        </li>
        <li>
          <Link to="Python.html"><del>Python</del></Link>
        </li>
        <li>
          <Link to="SoftwLinkreEngineering.html"><del>Software Engineering</del></Link>
        </li>
        <li>
          <Link to="Unix.html"><del>Unix</del></Link>
        </li>
        <li>
          <Link to="WebDesign.html"><del>Web Design</del></Link>
        </li>


</ul>

    </div>
    
    <div className="main">
    <Routes>
    <Route exact path="/" element={<Home/>}> </Route>
      <Route exact path="/about" element={<About />}> </Route>
      <Route exact path="/search" element={<Search/>}> </Route>
      <Route exact path="/books" element={<Books bk={bk} subject={subject}/>}> </Route>
      <Route exact path="/contact" element={<Contact/>}> </Route>
      </Routes>
    </div>
    
  </div>
</>

  )
}
